import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

export default function Layout() {
  return (
    <div className="portal-layout">
      <Navbar />
      <div className="portal-body">
        <Sidebar />
        <main className="portal-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
